import StandaloneSpaceContainer from './container';

export const SPACE_ID = 'standalone';

// Bypass asSpace: the iframe bootstraps its own auth via postMessage and shouldn't
// block on the global app-store init that asSpace's withZustandStore enforces.
export default StandaloneSpaceContainer;
